import React, { Component } from 'react';
import { Button, Col, Flex, InputNumber, Row, Select } from 'antd';
import Text from 'antd/es/typography/Text';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { ChoiceGroup } from '../components';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { ReactComponent as AddGameIcon } from '../assets/addGame.svg';

const countGames = [1, 2, 3, 4, 5];

class _CreateGamePanel extends Component<IRootStoreProps> {
  static contextType = AppContext;
  render() {
    const { isMobile, globalTheme } = this.context as AppContextValue;
    const { game, loading } = this.props.store;

    const styleChoiceGroup = isMobile
      ? {
          height: 42,
          marginTop: 10,
        }
      : undefined;

    const styleRow = isMobile ? { padding: 0, paddingBottom: 10 } : { padding: 10, paddingBottom: 30 };

    return (
      <Row style={styleRow}>
        <Col xs={24} sm={12} style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Flex vertical>
            <Text type="secondary">{'Ставка:'}</Text>
            <InputNumber
              style={{ width: 100, height: 40, marginTop: 10 }}
              step={0.1}
              min={0.1}
              value={game.newGame.amount}
              onChange={game.setAmountGames}
            />
          </Flex>
          <Flex vertical>
            <Text type="secondary">{'Количество игр:'}</Text>
            <Select
              style={{ width: 100, height: 40, marginTop: 10 }}
              defaultValue={countGames[0]}
              value={game.newGame.count}
              onChange={game.setCountGames}
            >
              {countGames.map(c => (
                <Select.Option key={c} value={c}>
                  {c}
                </Select.Option>
              ))}
            </Select>
          </Flex>
        </Col>
        <Col xs={24} sm={12} style={{ display: 'flex', justifyContent: 'space-around', marginTop: 10 }}>
          <Flex vertical>
            <Text type="secondary">{'Предмет:'}</Text>
            <ChoiceGroup
              value={game.newGame.choice}
              onChange={game.updateNewGame}
              type={game.newGame.type}
              style={styleChoiceGroup}
            />
          </Flex>
          <Flex justify={'flex-end'} style={{ height: 70 }} align={'flex-end'}>
            <Button
              type={'text'}
              style={{ padding: 25, backgroundColor: globalTheme?.blue6, borderRadius: 10 }}
              onClick={game.create}
              loading={loading}
              icon={<AddGameIcon style={{ width: 50, height: 50 }} />}
            />
          </Flex>
        </Col>
      </Row>
    );
  }
}

export const CreateGamePanel: WithoutStore = withStore(observer(_CreateGamePanel));
